import { useEffect, useState } from "react";
import CtaBanner from "../components/CtaBanner";

export default function AboutPage() {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    document.title = "Om os - Kærby Tømrer- & Snedkerforretning ApS";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Mød Kærby Tømrer- & Snedkerforretning ApS. Vi er din lokale og pålidelige håndværker i Gjerlev, Randers, Mariager og Hadsund."
      );
    }

    fetch("https://api.dev.auxo.dk/public/v2/content/pages?page_slug=om-os")
      .then((res) => res.json())
      .then((data) => {
        if (data && data.items && data.items.length > 0) {
          setPageData(data.items[0]);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="bg-white min-h-screen space-y-0 text-stone-900">
      
      {/* Header */}
      <section className="relative bg-zinc-900 text-white pt-20 sm:pt-24 pb-16 sm:pb-20 border-b border-zinc-800 -mt-14 sm:-mt-16 z-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
          <span className="text-[#ea580c] font-bold text-xs uppercase tracking-widest bg-zinc-950 px-3.5 py-1 rounded-full inline-block border border-zinc-800">
            Om Virksomheden
          </span>
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight uppercase text-white">
            Om Kærby Tømrer- & Snedkerforretning ApS
          </h1>
          <p className="text-stone-300 text-base sm:text-lg max-w-2xl">
            Lokal tømrer- og snedkerforretning baseret i Gjerlev. Vi bygger med faglig stolthed.
          </p>
        </div>
      </section>

      {/* Main Body */}
      <section className="py-16 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            <div className="lg:col-span-7 space-y-6">
              <h2 className="text-2xl sm:text-4xl font-extrabold uppercase text-stone-900">
                Kvalitet og punktlighed i højsædet
              </h2>

              <div
                className="prose rich-content max-w-none text-stone-800 [&_h1]:hidden"
                dangerouslySetInnerHTML={{
                  __html: (pageData?.content || `
                    <p>Kærby Tømrer- & Snedkerforretning ApS blev grundlagt med en klar vision: at levere solidt, jysk håndværk i højeste kvalitet til gennemskuelige priser og med aftaler, der overholdes.</p>
                    <p>Med udgangspunkt i Kærby Møllevej 2 i Gjerlev betjener vi kunder i hele Randers, Hadsund, Mariager og omegn. Vores hold af engagerede tømrere og snedkere tager stolthed i hver enkelt opgave – lige fra udskiftning af et enkelt vindue til opførelse af nøglefærdige nybyggerier og store erhvervsprojekter.</p>
                    <h3>Vores kerneværdier</h3>
                    <ul>
                      <li><strong>Faglig stolthed:</strong> Snedkerpræcision i alt hvad vi leverer.</li>
                      <li><strong>Pålidelighed:</strong> En aftale er en aftale – både om pris og tid.</li>
                      <li><strong>Tæt dialog:</strong> Vi rådgiver dig hele vejen gennem projektet.</li>
                    </ul>
                  `).replace(/<h1[^>]*>[\s\S]*?<\/h1>/gi, '')
                }}
              />

              <ul className="space-y-4 pt-4 border-t border-stone-200 text-left">
                <li className="flex items-start gap-3">
                  <i className="fa-solid fa-award text-xl text-[#ea580c] mt-0.5 shrink-0" aria-hidden="true" />
                  <div>
                    <h3 className="font-bold text-stone-900 text-sm uppercase">Høj Kvalitet</h3>
                    <p className="text-xs text-stone-600">Gennemført finish i alt træarbejde</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fa-solid fa-handshake text-xl text-[#ea580c] mt-0.5 shrink-0" aria-hidden="true" />
                  <div>
                    <h3 className="font-bold text-stone-900 text-sm uppercase">Aftaler Overholdes</h3>
                    <p className="text-xs text-stone-600">Præcise tidsplaner og priser</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fa-solid fa-location-dot text-xl text-[#ea580c] mt-0.5 shrink-0" aria-hidden="true" />
                  <div>
                    <h3 className="font-bold text-stone-900 text-sm uppercase">Lokal Forankring</h3>
                    <p className="text-xs text-stone-600">Randers, Hadsund, Mariager</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="lg:col-span-5">
              <div>
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/kf.jpg"
                  alt="Kærby Tømrer Mester"
                  className="w-full h-auto object-cover rounded-none"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      <CtaBanner />

    </div>
  );
}
